import { makeStyles } from 'tss-react/mui';
import { withStyles } from 'tss-react/mui';
import { PickersTextField } from '@mui/x-date-pickers/PickersTextField';
import { themeColors } from 'app/shared/theme';

export const StyledTextField = withStyles(PickersTextField, {
  root: {
    '& label.Mui-focused': {
      color: themeColors.greyscale3,
      borderColor: themeColors.mbsBlue,
    },

    '& .MuiPickersOutlinedInput-root': {
      padding: '10px 9px !important',
      marginBottom: 7,
      height: 44,
      borderRadius: '2px !important',
      '&:notchedOutline': {
        borderColor: 'red',
      },

      '&.Mui-focused fieldset': {
        borderColor: themeColors.mbsBlue,
      },
    },
    '&.MuiFormHelperText-root ': {
      marginLeft: '-10px',
      marginTop: '-10px',
      height: 0,
    },
  },
});

export const useStyles = makeStyles()({
  input: {
    padding: '12px 10px !important',
    fontSize: '14px',
    lineHeight: '22px',
    height: 44,
    boxSizing: 'border-box',
  },
  root: {
    '& label.Mui-focused': {
      color: themeColors.greyscale3,
      borderColor: themeColors.mbsBlue,
    },
    '&.Mui-focused ': {
      borderColor: themeColors.white,
    },
    '&.MuiOutlinedInput-multiline': {
      padding: 0,
    },
    margin: 0,
    height: 44,
  },
  contained: {
    marginLeft: '0px !important',
    marginTop: '-5px !important',
    color: themeColors.greyscale2,
    height: 0,
  },
});
